import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import ContactFormDialog from './ContactFormDialog';

export const Footer = () => {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <footer className="bg-[#2C1810] text-white relative overflow-hidden" data-testid="footer">
        {/* Decorative background elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#06214c]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#D4A574]/5 rounded-full blur-3xl"></div>
        
        <div className="container mx-auto px-4 py-16 relative z-10">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-10 gap-12 mb-16">
            
            {/* Column 1: Brand & Description */}
            <div className="lg:col-span-3">
              <Link to="/" className="inline-block mb-6">
                <img src="/assets/img/logo-white.png" className="h-12" alt="ipprotectionassociate Logo" />
              </Link>
              <p className="text-gray-300 leading-relaxed mb-6">
                Protecting your intellectual property with professional trademark registration services across the United States.
              </p>
              {/* CTA Buttons in Footer */}
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={() => setShowDialog(true)}
                  className="bg-[#bf8a60] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#a0733e] transition-all transform hover:scale-105 shadow-md"
                >
                  Get Started
                </button>
                <button className="js-chat border-2 border-[#bf8a60] text-[#bf8a60] px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#bf8a60] hover:text-white transition-all">
                  Chat Now
                </button>
              </div>
            </div>

          {/* Column 2: Services */}
          <div className="lg:col-span-2">
            <h3 className="text-xl font-bold mb-6" style={{ fontFamily: 'Playfair Display' }}>
              Services
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services/trademark-registration" className="text-gray-300 hover:text-[#D4A574] transition-colors inline-block">
                  Trademark Registration
                </Link>
              </li>
              <li>
                <Link to="/services/trademark-search" className="text-gray-300 hover:text-[#D4A574] transition-colors inline-block">
                  Trademark Search
                </Link>
              </li>
              <li>
                <Link to="/services/copyright-registration" className="text-gray-300 hover:text-[#D4A574] transition-colors inline-block">
                  Copyright Registration
                </Link>
              </li>
              <li>
                <Link to="/services/company-formation" className="text-gray-300 hover:text-[#D4A574] transition-colors inline-block">
                  Company Formation
                </Link>
              </li>
              <li>
                <Link to="/services/amazon-brand-registry" className="text-gray-300 hover:text-[#D4A574] transition-colors inline-block">
                  Amazon Brand Registry
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Company */}
          <div className="lg:col-span-2">
            <h3 className="text-xl font-bold mb-6" style={{ fontFamily: 'Playfair Display' }}>
              Company
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#D4A574] transition-colors inline-block">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#D4A574] transition-colors inline-block">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#D4A574] transition-colors inline-block">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Legal */}
          {/* <div className="lg:col-span-1">
            <h3 className="text-xl font-bold mb-6" style={{ fontFamily: 'Playfair Display' }}>
              Legal
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy-policy" className="text-gray-300 hover:text-[#D4A574] transition-colors inline-block">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-300 hover:text-[#D4A574] transition-colors inline-block">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div> */}

          {/* Column 5: Contact Information */}
          <div className="lg:col-span-3">
            <h3 className="text-xl font-bold mb-6" style={{ fontFamily: 'Playfair Display' }}>
              Contact Us
            </h3>
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <Phone size={14} className="flex-shrink-0" />
                <a href="tel:+1 (877) 946-4330" className="text-gray-300 hover:text-[#D4A574] transition-colors">+1 (877) 946-4330</a>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={14} className="flex-shrink-0" />
                <a href="mailto:info@ipprotectionassociate.com" className="text-gray-300 hover:text-[#D4A574] transition-colors">info@ipprotectionassociate.com</a>
              </div>
              <div className="flex items-center gap-2">
                <MapPin size={14} className="flex-shrink-0" />
                <span className="text-gray-300">Old Middlefield Way, Mountain View, CA 94043</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {new Date().getFullYear()} IP Protection Associate. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-[#D4A574] text-sm transition-colors">
                Privacy Policy
              </Link>
              <span className="text-gray-600">|</span>
              <Link to="/terms-of-service" className="text-gray-400 hover:text-[#D4A574] text-sm transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <ContactFormDialog open={showDialog} onOpenChange={setShowDialog} source="footer" />
    </>
  );
};

export default Footer;